import { Group, ActionIcon, Image, Box } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import classes from './app-header.module.css';

import { LangSelect } from '@ui';

interface AppHeaderProps {
  logout: () => void;
}

export function AppHeader({ logout }: AppHeaderProps) {
  const { t } = useTranslation();

  return (
    <Group className={classes.container} h="100%" justify="space-between" wrap="nowrap">
      <Group className={classes.logoWrapper} h="100%">
        <Box className={classes.logoContainer}>
          <Image
            alt="Empreinte Logo"
            fit="contain"
            flex={1}
            h="100%"
            src="/empreinte-logo.png"
          />
        </Box>
      </Group>
      <Group className={classes.actions}>
        <LangSelect />
        <ActionIcon
          aria-label={t('auth.logout')}
          color="white"
          onClick={logout}
          size={40}
          variant="subtle"
        >
          <IconLogout
            stroke={1.5}
            style={{ width: '100%', height: '100%' }}
          />
        </ActionIcon>
      </Group>
    </Group>
  );
}

export default AppHeader;
